<template>
  <div class="group container">
    <entry-index :step="4"></entry-index>
    <h3>登録内容の確認</h3>
    <div class="row">
      <div class="col-4">学校住所</div>
      <div class="col-8">
        <span>〒{{$store.getters['entry/dispZipCode']}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4"></div>
      <div class="col-8">
        <span>{{$store.getters['entry/address']}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4">学校名</div>
      <div class="col-8">
        （<span id="certFounder">{{$store.getters['entry/schoolFounderName']}}</span>）
        <span id="certSchoolName">{{$store.getters['entry/schoolName']}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-4">代表者氏名</div>
      <div class="col-8">
        <span id="certTeacherName">{{$store.getters['entry/teacherName']}}</span>（<span id="certTeacherKana">{{$store.getters['entry/teacherKana']}}</span>）
      </div>
    </div>
    <div class="row">
      <div class="col-4">電話番号</div>
      <div class="col-8"><span id="certTel">{{$store.getters['entry/tel']}}</span></div>
    </div>
    <div class="row">
      <div class="col-4">メールアドレス</div>
      <div class="col-8"><span id="certMail">{{$store.getters['entry/mail']}}</span></div>
    </div>
    <div class="row">
      <div class="col-4">受講教科</div>
      <div class="col-8"><span id="certMail">{{convSubject(this.$store.getters['entry/subject'])}}</span></div>
    </div>
    <div class="row">
      <div class="col-4">お支払い金額</div>
      <div class="col-8"><span>{{$store.getters['entry/dispCharge']}}円（税込）</span></div>
    </div>
    <div class="row" v-if="$store.getters['entry/payment'] == 'bill'">
      <div class="col-4">請求書の宛名</div>
      <div class="col-8"><span id="certReceipt">{{$store.getters['entry/dispReceipt']}}</span></div>
    </div>
    <div class="row">
      <div class="col-12">
        ※第一学習社「個人情報の保護について」にご同意いただきました。
      </div>
    </div>

    <!-- ナビゲーションボタン -->
    <div class="form-row">
      <div class="col-6">
        <button type="button" class="btn btn-lg btn-default btn-block prev_button" @click="onClickPrev">
          <i class="fas fa-chevron-circle-left"></i>　送付先情報入力選択へ
        </button>
      </div>
      <div class="col-6">
        <form>
          <button type="submit" class="btn btn-lg btn-primary btn-block next_button" @click.prevent="onSubmit">上記内容で登録</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import EntryIndex from "@/components/EntryIndex.vue"
import axios from 'axios'
import err from '@/err'

export default {
  name: 'EntryConfirm',
  data() {
    return {
      submitGuard: false
    }
  },
  components: {
    EntryIndex
  },
  computed: {
    dispEntrant() {
      return this.$store.getters['entry/dispEntrant']
    },
    anyWaiting() {
      return this.dispEntrant.find(e => e.waiting) !== undefined
    }
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
  },
  methods: {
    onClickPrev() {
      this.$router.back()
    },
    onSubmit(evt) {
      evt.target.disabled = true
      window.console.log('confirm submit')
      let params = this.$store.getters['entry/submitParams']
      params.forEach((val, key) => {
        window.console.log(key, val)
      })
      //window.console.log('submit params:', params.toString())
      axios.post(process.env.VUE_APP_BASE_URL + "api/submit.asp", params)
        .then(res => {
          window.console.log('submit result:', res.data)
          this.$store.dispatch("entry/setSubmitResult", { data: res.data })
          evt.target.disabled = false
          this.$router.push('result')
        })
        .catch(e => {
          window.console.warn('error', e)
          this.$store.dispatch("entry/setSubmitResult", { data: {state: err.UNKNOWN} })
          evt.target.disabled = false
          this.$router.push('result')
        })
    },
    convSubject(code) {
      if(code == '30') return '国語'
      if(code == '40') return '理科'
      if(code == '50') return '地歴･公民'
    }
  }
}
</script>
